import { Outlet } from 'react-router';

import { AdminRouteActions } from './AdminRouteActions';
import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function AdminLayout() {
  return (
    <HeaderToolbarAndContentLayout
      preContent={<div />}
      actionSection={<AdminRouteActions />}
      content={<Outlet />}
    />
  );
}
